"use client";

import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapsibleBioProps {
  bio: string;
  maxLength?: number;
}

export function CollapsibleBio({ bio, maxLength = 280 }: CollapsibleBioProps) {
  const [isOpen, setIsOpen] = useState(false);
  const shouldTruncate = bio.length > maxLength;

  if (!shouldTruncate) {
    return <p className="text-pretty text-sm text-muted-foreground">{bio}</p>;
  }

  return (
    <Collapsible open={isOpen} onOpenChange={setIsOpen}>
      <div className="space-y-2">
        <div className="text-pretty text-sm text-muted-foreground">
          {!isOpen ? (
            <>
              {bio.slice(0, maxLength)}
              <span className="text-muted-foreground/50">...</span>
            </>
          ) : (
            bio
          )}
        </div>
        <CollapsibleTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="h-auto p-0 text-muted-foreground hover:text-foreground"
          >
            {isOpen ? (
              <div className="flex items-center gap-1">
                Show less <ChevronUp className="h-3 w-3" />
              </div>
            ) : (
              <div className="flex items-center gap-1">
                Show more <ChevronDown className="h-3 w-3" />
              </div>
            )}
          </Button>
        </CollapsibleTrigger>
      </div>
    </Collapsible>
  );
}
